import React from 'react';
import { ArrowRight } from '@phosphor-icons/react';
import { Slide } from '../Slide';
import { InView } from '../InView';
import { SlideHeadline } from '../SlideHeadline';
import { CtaGlyph } from '../CtaGlyph';
import { actionCtas, journey, screenshots } from '../../../data/deck';
import type { StageId } from '../../../data/deck';
const attractVideoUrl = 'https://cdn.magicpatterns.com/uploads/8k9WSWP2qSj2f3pZuMHLb9/filteks-1080x1080.mp4';
const attractChannels = ['Email', 'Banner', 'LinkedIn', 'Congress'];
export function JourneySlide() {
  return <Slide id="journey" data-id="element-302" data-mp="xc02u6fnvudf">
      <InView data-id="element-303" data-mp="seqhp2zb24ve">
        <SlideHeadline lead="From attention" follow="to action." data-id="element-304" data-mp="segqjc2ixro4" />
      </InView>

      <div className="mt-14 grid gap-12 lg:grid-cols-[1fr_auto_1fr_auto_1fr] lg:gap-6" data-id="element-305" data-mp="ng5gb08bhf5d">
        {journey.map((stage, i) => <React.Fragment key={stage.id} data-id="element-306" data-mp="ih2d7lbwdj01" data-mpi={i}>
            <InView delay={0.12 + i * 0.12} data-id="element-307" data-mp="iiwv0qrvguzw">
              <div className="flex h-[280px] items-center justify-center rounded-[28px] bg-[#EFECE4]" data-id="element-308" data-mp="eeywah6glm7d">
                <StageVisual id={stage.id} data-id="element-309" data-mp="2g9nd91uu0dra" />
              </div>
              <div className="mt-6 flex items-baseline gap-3" data-id="element-310" data-mp="2l0nbcafot1vd">
                <span className="font-body text-[10px] tabular-nums tracking-[0.2em] text-[rgba(1,51,43,0.4)]" data-id="element-311" data-mp="2l284bvmcscr4">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h3 className="font-heading text-[30px] uppercase leading-none tracking-[0.02em] text-background" data-id="element-312" data-mp="2bblw4mgyuoig">
                  {stage.name}
                </h3>
              </div>
              <p className="mt-3 font-body text-[13.5px] leading-relaxed text-background" data-id="element-313" data-mp="33zrfp5waa7gp">
                {stage.channels}
              </p>
              <p className="mt-1.5 font-body text-[13px] leading-relaxed text-[rgba(1,51,43,0.55)]" data-id="element-314" data-mp="2q1t6eewtl182">
                {stage.goal}
              </p>
            </InView>
            {i < journey.length - 1 && <span aria-hidden="true" className="hidden h-[280px] items-center text-[rgba(1,51,43,0.35)] lg:flex" data-id="element-315" data-mp="1emxrcru9gxqz">
                <ArrowRight size={22} data-id="element-316" data-mp="3l7ir1jot2jaz" />
              </span>}
          </React.Fragment>)}
      </div>

      <InView delay={0.4} data-id="element-317" data-mp="3gbtxbwzgvwml">
        <p className="mt-14 flex flex-wrap items-center gap-x-4 gap-y-1 border-t border-[rgba(1,51,43,0.12)] pt-8 font-heading text-[26px] leading-[1.15] tracking-[-0.02em] text-background sm:text-[32px]" data-id="element-318" data-mp="3bir0nfze8726">
          <span data-id="element-319" data-mp="32i2iqa6vpmk0">Humanize the products.</span>
          <span aria-hidden="true" className="h-2 w-2 rounded-full bg-primary" data-id="element-320" data-mp="32jx6rxdg5usb" />
          <span data-id="element-321" data-mp="2xi7sm8uxh100">Simplify the experience.</span>
          <span aria-hidden="true" className="h-2 w-2 rounded-full bg-primary" data-id="element-322" data-mp="2xllwxmn5jka3" />
          <span data-id="element-323" data-mp="2skepjoox8n3y">Drive meaningful actions.</span>
        </p>
      </InView>
    </Slide>;
}
function StageVisual({
  id
}: {
  id: StageId;
}) {
  if (id === 'attract') {
    return <div className="flex flex-col items-center gap-3" data-id="element-324" data-mp="qri8nl8byqbx">
        <video src={attractVideoUrl} autoPlay loop muted playsInline preload="auto" aria-label="Animated Meet the Filteks hook" className="block h-[200px] w-[200px] rounded-[16px] bg-background object-cover shadow-[0_20px_40px_-24px_rgba(1,51,43,0.6)]" data-id="element-325" data-mp="ltyipo29sp45" />
        <div className="flex max-w-[240px] flex-wrap justify-center gap-1.5" data-id="element-326" data-mp="133kkfvou1l9w">
          {attractChannels.map(channel => <span key={channel} className="rounded-full bg-white px-3 py-1 font-body text-[10.5px] text-background ring-1 ring-[rgba(1,51,43,0.1)]" data-id="element-327" data-mp="1848cmkoss85p">
              {channel}
            </span>)}
        </div>
      </div>;
  }
  if (id === 'convince') {
    return <div className="relative w-[90%] overflow-hidden rounded-[14px] shadow-[0_24px_50px_-28px_rgba(1,51,43,0.6)] ring-1 ring-[rgba(1,51,43,0.08)]" style={{
      aspectRatio: '1824 / 1148'
    }} data-id="element-328" data-mp="pbmetuuby7ih">
        <img src={screenshots.websiteSnak} alt="Meet the Filteks Snak opened on the website: the family portrait with Firstborn, Middle child, Youngest and Caboose child" className="absolute block max-w-none" style={{
        width: '141.24%',
        left: '-20.72%',
        top: 0,
        marginTop: '-9.76%'
      }} data-id="element-329" data-mp="20q9sona4ou47" />
      </div>;
  }
  return <div className="grid w-[260px] grid-cols-2 gap-2 rounded-[18px] bg-background p-3" data-id="element-330" data-mp="3imbj0f46osu4">
      {actionCtas.map(cta => <span key={cta.icon} className="flex items-center gap-2 rounded-[10px] border border-white/70 px-2.5 py-2.5 font-body text-[11px] text-white" data-id="element-331" data-mp="3smc528tftn20">
          <CtaGlyph icon={cta.icon} size={15} data-id="element-332" data-mp="3nlof7qgy3c9d" />
          {cta.short}
        </span>)}
    </div>;
}